import { NgModule } from '@angular/core';
import { NgxQueryEditorComponent } from './ngx-query-editor.component';
import { QueryAreaModule } from './query-area/query-area.module';
import { ToolbarModule } from './toolbar/toolbar.module';
import { DbExplorerModule } from './db-explorer/db-explorer.module';
import { ResultViewerModule } from './result-viewer/result-viewer.module';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { HttpClientModule } from '@angular/common/http';
import { MatDividerModule } from '@angular/material';


@NgModule({
  declarations: [NgxQueryEditorComponent],
  imports: [
    QueryAreaModule,
    ToolbarModule,
    DbExplorerModule,
    ResultViewerModule,
    CommonModule,
    MatIconModule,
    MatDividerModule,
    HttpClientModule
  ],
  providers: [],
  exports: [NgxQueryEditorComponent]
})
export class NgxQueryEditorModule { }
